import React from 'react';
import {useLoading} from "../../../../util/LoadingProvider";
import apiHelper from "../../../../util/ApiHelper";
import {Controller, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup/dist/yup";
import * as yup from "yup";
import Box from "@material-ui/core/Box";
import {Button, makeStyles} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import UploadImage from "../../UploadImage";
import {ToggleButton, ToggleButtonGroup} from "@material-ui/lab";
import {toast} from "react-toastify";
import {useHistory} from "react-router";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import editorConfiguration from "../../../../util/EditorConfiguration";

const useStyles = makeStyles((theme) => ({
  tabpanel: {
    background: "#FFFFFF",
  },
  textInput: {
    backgroundColor: "white",
    width: "100%",
    marginBottom: "12px",

    "& input": {
      fontSize: "14px",
    },
  },
  content: {
    "& .ck-editor__editable_inline": {
      minHeight: "200px",
    },
  },
  buttonGroup: {
    marginTop: "20px",
    textAlign: "right",
    "& button": {
      color: "#306F9D",
      fontSize: "13px",
      textTransform: "inherit",
    },
  },
  box: {
    padding: 0,
  },
  innerBox: {
    background: "#ffffff",
    padding: theme.spacing(3),
    marginBottom: theme.spacing(4),
  },
  imageGallery: {
    border: "1px solid #CCCCCC",
    minHeight: "160px",
    borderRadius: "3px",
    position: "relative",
  },
  imageGalleryControl: {
    position: "relative",
    width: "100%",
    display: "flex",
    height: "40px",
    bottom: "0",
    borderTop: "1px solid #CCCCCC",
    padding: "5px",
  },
  imageGalleryBlk: {
    minHeight: "120px",
    padding: "5px",
  },
  imgPreview: {
    maxWidth: "200px",
    margin: "10px",
    display: "inline-flex",
    position: "relative",
    verticalAlign: "top",
    "& img": {
      width: "100%",
      height: "auto",
    },
    "& button": {
      position: "absolute",
      top: "-10px",
      right: "-10px",
      zIndex: "10",
      display: "block",
      color: "rgba(48, 111, 157, 0.8)",
      background: "white",
      padding: 0,
      transition: "200ms all ease-out",
      "&:hover": {
        color: "rgba(48, 111, 157, 1)",
        background: "white",
      },
    },
  },
  permalink: {
    paddingLeft: "5px",
    fontSize: "13px",
    display: "flex",
    alignItems: "center",
    "& .permalink": {
      fontWeight: 700,
    },
  },
  input: {
    width: "100%",
    marginTop: "20px",
    marginLeft: "10px",
    "& button": {
      fontSize: "13px",
      lineHeight: "15px",
      width: "25%",
    },
  },
}));

const defaultFormValues = {
  localizations: {
    en: {
      title: "",
      content: "",
      image: null,
      url: ""
    },
    tc: {
      title: "",
      content: "",
      image: null,
      url: ""
    },
  },
  status: 1,
};

const schema = yup.object().shape({
  localizations: yup.object().shape({
    en: yup.object().shape({
      title: yup.string().required("Title is required."),
    }),
    tc: yup.object().shape({
      title: yup.string().required("Title is required."),
    }),
  }),
});

function TabPanel(props) {
  const classes = useStyles();
  const {children, value, index, ...other} = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`nav-tabpanel-${index}`}
      aria-labelledby={`nav-tab-${index}`}
      {...other}
    >
      <Box p={3} className={classes.box}>
        {children}
      </Box>
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `nav-tab-${index}`,
    "aria-controls": `nav-tabpanel-${index}`,
  };
}

export const EventDetailPage = ({match, disabled}) => {
  const {id} = match.params;
  const {setLoading} = useLoading();
  const history = useHistory();
  const classes = useStyles();
  const [activeTab, setActiveTab] = React.useState(0);
  const [eventCategories, setEventCategories] = React.useState([]);
  const [defaultValues, setDefaultValues] = React.useState(defaultFormValues);

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const {
    control,
    handleSubmit,
    watch,
    getValues,
    reset,
    setValue,
    formState,
  } = useForm({
    defaultValues: React.useMemo(() => defaultValues, [defaultValues]),
    resolver: yupResolver(schema),
  });

  const getEventCategories = async () => {
    try {
      setLoading(true);
      const response = await apiHelper.hkiff.getEventCategoryListing({unpaged: true});
      setEventCategories(response.data.content);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  }

  const getEventById = React.useCallback(async () => {
    try {
      setLoading(true);
      const res = await apiHelper.hkiff.getEventById(id);
      setDefaultValues(res.data);
    } catch (e) {
      console.log(e)
    } finally {
      setLoading(false);
    }
  }, [id])

  const onSubmit = async (data) => {
    if (id !== 'new') {
      try {
        setLoading(true)
        await apiHelper.hkiff.updateEventById(id, data);
        await getEventById()
        toast.success("Event updated successfully.");
      } catch (e) {
        console.log(e)
      } finally {
        setLoading(false)
      }
    } else {
      try {
        setLoading(true)
        const res = await apiHelper.hkiff.createEvent(data);
        toast.success("Event created successfully.");
        history.push(`/hkiff/event/${res.data.id}`)
      } catch (e) {
        console.log(e)
      } finally {
        setLoading(false)
      }
    }
  }

  React.useEffect(() => {
    async function init() {
      await getEventCategories();
      if (id && id !== 'new') {
        await getEventById()
      }
    }

    init()
  }, [id])

  React.useEffect(() => {
    reset(defaultValues)
  }, [reset, defaultValues])

  console.log({defaultValues})

  return (
    <div className={classes.content}>
      <Typography variant="h4" gutterBottom>
        Event > {id === 'new' ? 'Add New Event' : 'Edit Event'}
      </Typography>
      <Tabs
        value={activeTab}
        onChange={handleChange}
        aria-label="nav tabs example"
        TabIndicatorProps={{style: {top: "0", background: "#306F9D"}}}
      >
        <Tab
          label="English"
          {...a11yProps(0)}
        />
        <Tab
          label="繁體中文"
          {...a11yProps(1)}
        />
      </Tabs>
      <form onSubmit={handleSubmit(onSubmit)}>
        <fieldset disabled={disabled} className="fieldset">
          <TabPanel value={activeTab} index={0}>
            <Box className={classes.innerBox} style={{paddingTop: 32, marginBottom: 0}}>
              <Grid container direction="vertical" spacing={3}>
                <Grid item xs={12}>
                  <Controller
                    name={`localizations.en.title`}
                    control={control}
                    render={({field, fieldState: {error}}) => (
                      <TextField
                        label="Title"
                        variant="outlined"
                        margin="dense"
                        className={classes.textInput}
                        fullWidth
                        {...field}
                        defaultValue={field.value}
                        error={!!error}
                        helperText={error ? error.message : ""}
                      />
                    )}
                  />
                </Grid>
                <Grid container item xs={12}>
                  <Grid item xs={6}>
                    <FormControl variant="outlined" margin="dense" className={classes.formControl}
                                 style={{width: "100%"}}>
                      <InputLabel htmlFor="outlined-age-native-simple">Select Category</InputLabel>
                      <Controller
                        name={`categoryId`}
                        control={control}
                        render={({field, fieldState: {error}}) => (
                          <Select
                            native
                            label="Select Category"
                            {...field}
                            inputProps={{
                              name: 'categoryId',
                              id: 'outlined-category-native-simple',
                            }}
                          >
                            <option value={null}>None</option>
                            {eventCategories.map((o) => {
                              return (<option key={o.id} value={o.id}>{o.nameEn}</option>)
                            })}
                          </Select>
                        )}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={6}>
                    <FormControl variant="outlined" margin="dense" className={classes.formControl}
                                 style={{width: "100%"}}>
                      <InputLabel htmlFor="outlined-age-native-simple">Select Subcategory</InputLabel>
                      <Controller
                        name={`subcategoryId`}
                        control={control}
                        render={({field, fieldState: {error}}) => (
                          <Select
                            native
                            label="Select Subcategory"
                            {...field}
                            inputProps={{
                              name: 'subcategoryId',
                              id: 'outlined-category-native-simple',
                            }}
                          >
                            <option value={null}>None</option>
                          </Select>
                        )}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Grid item xs={6}>
                    {defaultValues && (
                      <UploadImage
                        name="localizations.en.image"
                        data={defaultValues}
                        control={control}
                        Controller={Controller}
                        setValue={setValue}
                        getValues={getValues}
                        disabled={disabled}
                        uploadLabel="Image"
                        changeLabel="Image"
                        uploadFolder="EVENT"
                      />
                    )}
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name={`localizations.en.url`}
                    control={control}
                    render={({field, fieldState: {error}}) => (
                      <TextField
                        label="URL"
                        variant="outlined"
                        margin="dense"
                        className={classes.textInput}
                        fullWidth
                        {...field}
                        defaultValue={field.value}
                        error={!!error}
                        helperText={error ? error.message : ""}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Box
                    fontWeight={900}
                    fontSize={13}
                    mb={2}
                    mt={2}
                    width="100%"
                  >
                    <Typography variant="p">Content</Typography>
                  </Box>
                  <Controller
                    name="localizations.en.content"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <CKEditor
                        editor={Editor}
                        config={editorConfiguration}
                        data={field.value || ""}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          field.onChange(data);
                        }}
                        disabled={disabled}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} container direction="vertical" spacing={3}>
                  <Grid item xs={4}>
                    <Controller
                      control={control}
                      name="status"
                      render={({
                                 field: {value, onChange, ...rest},
                                 fieldState: {error},
                               }) => (
                        <ToggleButtonGroup
                          {...rest}
                          value={value}
                          onChange={(event, newFormats) => {
                            if (newFormats !== null) {
                              onChange(newFormats);
                            }
                          }}
                          exclusive
                          aria-label="Status"
                          className={classes.input}
                        >
                          <ToggleButton
                            value={1}
                            aria-label="Active"
                            style={{width: "50%"}}
                          >
                            Active
                          </ToggleButton>
                          <ToggleButton
                            value={0}
                            aria-label="Inactive"
                            style={{width: "50%"}}
                          >
                            Inactive
                          </ToggleButton>
                        </ToggleButtonGroup>
                      )}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </TabPanel>
          <TabPanel value={activeTab} index={1}>
            <Box className={classes.innerBox} style={{paddingTop: 32, marginBottom: 0}}>
              <Grid container direction="vertical" spacing={3}>
                <Grid item xs={12}>
                  <Controller
                    name={`localizations.tc.title`}
                    control={control}
                    render={({field, fieldState: {error}}) => (
                      <TextField
                        label="Title"
                        variant="outlined"
                        margin="dense"
                        className={classes.textInput}
                        fullWidth
                        {...field}
                        defaultValue={field.value}
                        error={!!error}
                        helperText={error ? error.message : ""}
                      />
                    )}
                  />
                </Grid>
                <Grid container item xs={12}>
                  <Grid item xs={6}>
                    <FormControl variant="outlined" margin="dense" className={classes.formControl}
                                 style={{width: "100%"}}>
                      <InputLabel htmlFor="outlined-age-native-simple">Select Category</InputLabel>
                      <Controller
                        name={`categoryId`}
                        control={control}
                        render={({field, fieldState: {error}}) => (
                          <Select
                            native
                            label="Select Category"
                            {...field}
                            inputProps={{
                              name: 'categoryId',
                              id: 'outlined-category-native-simple',
                            }}
                          >
                            <option value={null}>None</option>
                            {eventCategories.map((o) => {
                              return (<option key={o.id} value={o.id}>{o.nameEn}</option>)
                            })}
                          </Select>
                        )}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={6}>
                    <FormControl variant="outlined" margin="dense" className={classes.formControl}
                                 style={{width: "100%"}}>
                      <InputLabel htmlFor="outlined-age-native-simple">Select Subcategory</InputLabel>
                      <Controller
                        name={`subcategoryId`}
                        control={control}
                        render={({field, fieldState: {error}}) => (
                          <Select
                            native
                            label="Select Subcategory"
                            {...field}
                            inputProps={{
                              name: 'subcategoryId',
                              id: 'outlined-category-native-simple',
                            }}
                          >
                            <option value={null}>None</option>
                          </Select>
                        )}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Grid item xs={6}>
                    {defaultValues && (
                      <UploadImage
                        name="localizations.tc.image"
                        data={defaultValues}
                        control={control}
                        Controller={Controller}
                        setValue={setValue}
                        getValues={getValues}
                        disabled={disabled}
                        uploadLabel="Image"
                        changeLabel="Image"
                        uploadFolder="EVENT"
                      />
                    )}
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name={`localizations.tc.url`}
                    control={control}
                    render={({field, fieldState: {error}}) => (
                      <TextField
                        label="URL"
                        variant="outlined"
                        margin="dense"
                        className={classes.textInput}
                        fullWidth
                        {...field}
                        defaultValue={field.value}
                        error={!!error}
                        helperText={error ? error.message : ""}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Box
                    fontWeight={900}
                    fontSize={13}
                    mb={2}
                    mt={2}
                    width="100%"
                  >
                    <Typography variant="p">Content</Typography>
                  </Box>
                  <Controller
                    name="localizations.tc.content"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <CKEditor
                        editor={Editor}
                        config={editorConfiguration}
                        data={field.value || ""}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          field.onChange(data);
                        }}
                        disabled={disabled}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} container direction="vertical" spacing={3}>
                  <Grid item xs={4}>
                    <Controller
                      control={control}
                      name="status"
                      render={({
                                 field: {value, onChange, ...rest},
                                 fieldState: {error},
                               }) => (
                        <ToggleButtonGroup
                          {...rest}
                          value={value}
                          onChange={(event, newFormats) => {
                            if (newFormats !== null) {
                              onChange(newFormats);
                            }
                          }}
                          exclusive
                          aria-label="Status"
                          className={classes.input}
                        >
                          <ToggleButton
                            value={1}
                            aria-label="Active"
                            style={{width: "50%"}}
                          >
                            Active
                          </ToggleButton>
                          <ToggleButton
                            value={0}
                            aria-label="Inactive"
                            style={{width: "50%"}}
                          >
                            Inactive
                          </ToggleButton>
                        </ToggleButtonGroup>
                      )}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </TabPanel>

          {disabled || (
            <div className={classes.buttonGroup}>
              <Button
                type="submit"
                variant="contained"
                disableElevation
                style={{
                  color: "white",
                  background: "#306F9D",
                  marginRight: "5px",
                  padding: "9px 16px",
                }}
              >
                {id === 'new' ? 'Create' : 'Save Changes'}
              </Button>
            </div>
          )}
        </fieldset>
      </form>
    </div>
  )
}